// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e8fd9ead","864":"af13a062"}[chunkId] + ".chunk.js";
};